module.exports = __webpack_public_path__ + "static/media/six_monkeys.f7806374.gif";